<template>
	<div id="insights" class="module module--realtor-insights">
		<!--<BgBox src="header-realtor" :opacity="Number(.125)" :alt="_translate('m.insights.background.alt')" parallax>
			<div class="intro">
				<h2 v-html="_translate('m.insights.title')"></h2>
				<p v-html="_translate('m.insights.intro.a')"></p>
				<p v-html="_translate('m.insights.intro.b')"></p>
			</div>
		</BgBox>  	-->
		<div class="module__body">
			<div class="container">
				<div class="wrapper">
					<section id="bythenumbers">
						<h2 v-html="_translate('m.numbers.title')"></h2>
							<div class="intro">
								<p class="emphasis" v-html="_translate('m.numbers.intro')"></p>
								<p v-html="_translate('m.numbers.paragraph.a')"></p>
								<p v-html="_translate('m.numbers.paragraph.b')"></p>
							</div>
							<div class="grid grid--2-2 grid--gap">
							<Card>
								<template v-slot:front>
									<h4 class="half-leading" v-html="_translate('m.trendline.card.a.heading')"></h4>
									<p v-html="_translate('m.trendline.card.a.text')"></p>
									<SVGChart name="visitor-trendline" class="large" />
								</template>
							</Card>
							<Card>
								<template v-slot:front>
									<h4 class="half-leading" v-html="_translate('m.trendline.card.b.heading')"></h4>
									<p v-html="_translate('m.trendline.card.b.text')"></p>
									<SVGChart name="listing-trendline" class="large" />
								</template>
							</Card>
						</div>
						<InfoBox>
							<template v-slot:text>
								<p class="emphasis" v-html="_translate('m.trendline.market.paragraph.text')"></p>
							</template>
							<template v-slot:links>
								<a v-bind:href="_translate('m.trendline.market.link.a.url')" target="_blank">
									<span v-html="_translate('m.trendline.market.link.a.text')"></span>
									<Icon icon="ArrowRight"/>
								</a>
								<a v-bind:href="_translate('m.trendline.market.link.b.url')" target="_blank">
									<span v-html="_translate('m.trendline.market.link.b.text')"></span>
									<Icon icon="ArrowRight"/>
								</a>
							</template>
						</InfoBox>
						<div class="grid grid--2-2 grid--gap">
							<Card>
								<template v-slot:front>
									<Illustration name="aware-realtor" class="large" />
									<p class="stat" v-html="_translate('m.numbers.card.a.stat')"></p>
									<p v-html="_translate('m.numbers.card.a.text')"></p>
								</template>
							</Card>
							<Card>
								<template v-slot:front>
									<Illustration name="list" class="large" />
									<p class="stat" v-html="_translate('m.numbers.card.b.stat')"></p>
									<p v-html="_translate('m.numbers.card.b.text')"></p>
									<p class="highlight" v-html="_translate('m.numbers.card.b.highlight')"></p>
								</template>
							</Card>
							<Card>
								<template v-slot:front>
									<Illustration name="market-share" class="large" />
									<p class="stat" v-html="_translate('m.numbers.card.c.stat')"></p>
									<p v-html="_translate('m.numbers.card.c.text')"></p>
								</template>
							</Card>
							<Card>
								<template v-slot:front>
									<Illustration name="visitor-growth" class="large" />
									<p class="stat" v-html="_translate('m.numbers.card.d.stat')"></p>
									<p v-html="_translate('m.numbers.card.d.text')"></p>
								</template>
							</Card>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Icon from '@/components/Icon.vue'
	import InfoBox from '@/components/InfoBox.vue'
	import BgBox from '@/components/BgBox.vue'
	import Button from '@/components/Button.vue'
	import Card from '@/components/Card.vue'
	import Illustration from '@/components/Illustration.vue'
	import SVGChart from '@/components/SVGChart.vue'

	export default {

		name: 'RealtorInsights',

		components: {
			BgBox,
			Button,
			Card,
			Illustration,
			SVGChart,
			Icon,
			InfoBox,
		},
	}

</script>